const STORAGE_KEY = 'mangitalia_carrello';

export function loadCarrello() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveCarrello(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent('carrello-updated'));
}

export function addToCarrello(item) {
  const items = loadCarrello();
  const idx = items.findIndex((i) => i.categoria_catalogo_id === item.categoria_catalogo_id);
  if (idx >= 0) {
    items[idx].quantita = Math.min(999, items[idx].quantita + (item.quantita || 1));
  } else {
    items.push({
      categoria_catalogo_id: item.categoria_catalogo_id,
      nome: item.nome,
      prezzo_piatto: item.prezzo_piatto,
      quantita: item.quantita || 1,
    });
  }
  saveCarrello(items);
  return items;
}

export function updateQuantita(categoriaId, quantita) {
  const items = loadCarrello().map((i) =>
    i.categoria_catalogo_id === categoriaId ? { ...i, quantita: Math.max(1, quantita) } : i
  );
  saveCarrello(items);
  return items;
}

export function removeFromCarrello(categoriaId) {
  const items = loadCarrello().filter((i) => i.categoria_catalogo_id !== categoriaId);
  saveCarrello(items);
  return items;
}

export function clearCarrello() {
  saveCarrello([]);
}

export function carrelloCount() {
  return loadCarrello().reduce((s, i) => s + i.quantita, 0);
}
